import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../controllers/authService";
import { swalError, swalSuccess } from "../utils/swal";
import QuantusLogo from "../assets/img/Quantus-Invoice.png";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get("token");

  const [token, setToken] = useState(tokenFromUrl || "");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      swalError("Las contraseñas no coinciden", "Verifica que ambas sean idénticas.");
      return;
    }

    try {
      const response = await resetPassword(token, password);
      setMessage(response.mensaje);
      swalSuccess("Contraseña actualizada", response.mensaje || "Ya puedes iniciar sesión.");

      // Redirigir al login después de 2s
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError("No se pudo reestablecer la contraseña");
      swalError("No se pudo reestablecer la contraseña", "El enlace puede haber expirado.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-quantus-navy px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center bg-white rounded-2xl px-6 py-4 shadow-quantus-lg">
            <img src={QuantusLogo} alt="Quantus Invoice" style={{ width: 200 }} />
          </div>
        </div>
        <div className="bg-white p-7 rounded-2xl shadow-quantus-lg border border-white/10 w-full">
          <h2 className="text-xl font-display font-semibold mb-1 text-center text-blueGray-800">
            Reestablecer contraseña
          </h2>
          <p className="text-sm text-blueGray-400 text-center mb-6">
            Define tu nueva contraseña de acceso
          </p>

          <form onSubmit={handleSubmit}>
            {!tokenFromUrl && (
              <input
                type="text"
                placeholder="Token"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                className="w-full mb-3 px-4 py-3 rounded-lg border border-blueGray-200 text-blueGray-700 placeholder-blueGray-300 focus:outline-none focus:ring-2 focus:ring-quantus-blue-300 focus:border-quantus-blue-400 transition"
                required
              />
            )}

            <input
              type="password"
              placeholder="Nueva contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mb-3 px-4 py-3 rounded-lg border border-blueGray-200 text-blueGray-700 placeholder-blueGray-300 focus:outline-none focus:ring-2 focus:ring-quantus-blue-300 focus:border-quantus-blue-400 transition"
              required
            />

            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full mb-4 px-4 py-3 rounded-lg border border-blueGray-200 text-blueGray-700 placeholder-blueGray-300 focus:outline-none focus:ring-2 focus:ring-quantus-blue-300 focus:border-quantus-blue-400 transition"
              required
            />

            <button
              type="submit"
              className="w-full text-white text-sm font-display font-semibold uppercase tracking-wide py-3 rounded-lg bg-quantus-blue-500 hover:bg-quantus-blue-600 shadow-quantus transition-colors"
            >
              Cambiar contraseña
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
